import React, { Component } from 'react';
import qs from 'qs';
import { withRouter } from 'containers/withRouter';
import PropTypes from 'prop-types';
import StateFilter from 'components/StateFilter';
import CompanyNamePicker from 'components/CompanyNamePicker';
import { Button, Col, Container, Row, Spinner } from 'reactstrap';
import translate from 'containers/translate';
import { consumesUsedCompanies } from 'contexts/UsedCompaniesContext';
import { consumesDocumentIds } from 'contexts/DocumentIdsContext';
import { consumesDocument } from 'contexts/DocumentContext';
import RemoteDataPropType from 'lib/prop-types/RemoteDataPropType';
import './FilterBar.scss';

class FilterBar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      creatingManualBooking: false,
    };

    this.handleStateFilterChange = this.handleStateFilterChange.bind(this);
    this.handleCompanyNameFilterChange = this.handleCompanyNameFilterChange.bind(this);
    this.handleManualBookingClick = this.handleManualBookingClick.bind(this);
  }

  _getFilterFromURL() {
    const query = qs.parse(this.props.location.search, { strictNullHandling: true, ignoreQueryPrefix: true });

    return {
      state: '',
      companyName: '',
      ...query,
    };
  }

  updateURL(filter) {
    if (filter.state === '') {
      delete filter.state;
    }

    if (filter.companyName === '') {
      delete filter.companyName;
    }

    const filterString = qs.stringify(filter, { strictNullHandling: true, ignoreQueryPrefix: true });
    this.props.history.pushDossier(`/edit/?${filterString}`);
  }

  handleStateFilterChange(state) {
    const filter = {
      ...this._getFilterFromURL(),
      state,
    };

    this.updateURL(filter);
  }

  handleCompanyNameFilterChange(companyName) {
    const filter = {
      ...this._getFilterFromURL(),
      companyName,
    };

    this.updateURL(filter);
  }

  async handleManualBookingClick() {
    this.setState({
      creatingManualBooking: true,
    });

    try {
      await new Promise((resolve, reject) => {
        this.props.remoteDocument.api.create(
          {
            from: 'scratch',
            data: {},
          },
          (err, document) => {
            if (err) {
              return reject(err);
            }

            this.props.remoteDocumentIds.api.fetch(() => {
              this.props.history.pushDossier(`/edit/${document.id}`);
              resolve();
            });
          },
          true
        );
      });
    } finally {
      this.setState({ creatingManualBooking: false });
    }
  }

  render() {
    const { t } = this.props;
    const filter = this._getFilterFromURL();

    return (
      <div className={'FilterBar'}>
        <Container>
          <Row className={'align-items-center'}>
            <Col xs={'auto'}>{t('filter')}: </Col>
            <Col xs={'4'}>
              <StateFilter
                selectedState={filter.state}
                onStateFilterChange={this.handleStateFilterChange}
                lastUpdateRequested={new Date()}
              />
            </Col>
            <Col xs={'4'}>
              <CompanyNamePicker
                allCompanyNames={this.props.usedCompanyNames}
                usedCompanyNames={this.props.usedCompanyNames}
                presetCompanyName={filter.companyName}
                onCompanyNameChange={this.handleCompanyNameFilterChange}
                clearable={true}
              />
            </Col>
            <Col xs={'auto'} className="ml-auto">
              {this.state.creatingManualBooking ? (
                <Spinner />
              ) : (
                <Button color="primary" onClick={this.handleManualBookingClick}>
                  {t('manual_booking')}
                </Button>
              )}
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

FilterBar.propTypes = {
  t: PropTypes.func.isRequired,
  usedCompanyNames: PropTypes.array.isRequired,
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  remoteDocument: RemoteDataPropType,
  remoteDocumentIds: RemoteDataPropType,
};

export default consumesUsedCompanies(consumesDocument(consumesDocumentIds(withRouter(translate(FilterBar)))));
